import styled from 'styled-components'

export const StyledTripLeg = styled.div`
  background-color: ${prosp => prosp.theme.colors.white[500]};
  padding: ${props => props.theme.spacing.xlarge};
  border-radius: ${props => props.theme.radius.medium};
  border: 1px solid ${props => props.theme.colors.black[200]};
  gap: 1rem;
  margin-bottom: ${props => props.theme.spacing.medium};
  @media screen and (max-width: ${props => props.theme.screens.tablet}) {
    padding: ${props => props.theme.spacing.medium};
  }
`

export const TripLegHeader = styled.div`
  display: grid;
  grid-template-columns: 0.5fr 0.5fr 1fr;
  grid-gap: ${props => props.theme.spacing.medium};
  margin-bottom: ${props => props.theme.spacing.large};

  @media screen and (max-width: ${props => props.theme.screens.tablet}) {
    grid-template-columns: 1fr;
  }
`

export const TripLegHeaderPackageVehicle = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;

  & > div:not(:last-of-type) {
    margin-right: ${props => props.theme.spacing.default};
  }
`

export const TripLegFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-top: ${props => props.theme.spacing.large};
  margin-top: ${props => props.theme.spacing.large};
  border-top: 1px solid ${props => props.theme.colors.black[100]};

  button {
    &:first-child {
      margin-right: ${props => props.theme.spacing.default};
    }
  }
`

export const PdfButtonWrapper = styled.div`
  margin-bottom: ${props => props.theme.spacing.medium};
`
